export default "__VITE_ASSET__ClzEaRY6__"